/**
 * User-based authentication provider for browser usage
 * Uses JWT access token from auth session
 */
import { getLogger } from '@qwickapps/logging';
import { AuthenticationError } from '../types/errors.js';
const log = getLogger('QwickForge.MiddlewareClient.UserAuth');
export class UserAuthProvider {
    getAccessToken;
    userId;
    constructor(getAccessToken, userId) {
        this.getAccessToken = getAccessToken;
        this.userId = userId;
    }
    async getAuthHeaders() {
        try {
            const token = await this.getAccessToken();
            if (!token) {
                throw new AuthenticationError('Access token is empty');
            }
            const headers = {
                'Authorization': `Bearer ${token}`,
            };
            if (this.userId) {
                headers['X-User-ID'] = this.userId;
            }
            log.debug('User auth headers generated', { userId: this.userId });
            return headers;
        }
        catch (error) {
            log.error('Failed to get access token', {
                error: error instanceof Error ? error.message : String(error),
                userId: this.userId,
            });
            if (error instanceof AuthenticationError) {
                throw error;
            }
            throw new AuthenticationError(`Failed to get access token: ${error instanceof Error ? error.message : String(error)}`);
        }
    }
    hasCredentials() {
        // Assume token provider is valid if provided
        return true;
    }
    getAuthType() {
        return 'user';
    }
    getIdentifier() {
        return this.userId;
    }
    /**
     * Refresh token if the provider supports it
     */
    async refresh() {
        // Token refresh is handled by the token provider
        // This is a no-op for UserAuthProvider
        log.debug('Token refresh requested (handled by token provider)');
    }
}
//# sourceMappingURL=UserAuthProvider.js.map